var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_446_4047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 21.7574C16.5228 21.7574 21 17.2803 21 11.7574C21 6.2346 16.5228 1.75745 11 1.75745C5.47715 1.75745 1 6.2346 1 11.7574C1 17.2803 5.47715 21.7574 11 21.7574Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.7574C21 7.4578 18.2863 3.79237 14.4783 2.37944V21.1355C18.2863 19.7225 21 16.0571 21 11.7574Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11.7574C1 16.0571 3.71375 19.7225 7.52176 21.1355V2.37944C3.71375 3.79237 1 7.4578 1 11.7574Z",
    fill: "#B7D16D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_446_4047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(1 1.75745)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/it.da736fe341db0a5a6f765656fffbea4a.svg";
export { ForwardRef as ReactComponent };